/* eslint-disable angular/ng_angularelement */
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  'ProductNotFoundService',
  '$timeout',
  'CatalogService',
  'CartService'
];

class ProductNotFoundController{
  constructor ($scope,
               CategoryService,
               $state,
               $rootScope,
               SharedService,
               $stateParams,
               $uibModal,
               ProductNotFoundService,
               $timeout,
               CatalogService,
               CartService) {
    this.$state = $state;
    this.$scope = $scope;
    this.CatalogService = CatalogService;
    this.ProductNotFoundService = ProductNotFoundService;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.CartService = CartService;
    this.CategoryService = CategoryService;
    this.SharedService = SharedService;
    this.$timeout = $timeout;
    this.productSearchText = this.$stateParams.productSearchText;
    this.productNotFoundDataForm = {};
    this.mailSent = false;
  }
  
  sendMailProductNotFound () {
    this.productNotFoundDataForm.productSearchText = this.productSearchText;
    this.ProductNotFoundService.mailProductNotFound(this.productNotFoundDataForm).then(response => {
      if(!response.error) {
        this.mailSent = true;
      }
      else {
        alert(response.message);
      }
    }).catch(reason => {
      alert('Ha ocurrido un error al enviar el mensaje');
    });
  };

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

ProductNotFoundController.$inject = inject;

export default ProductNotFoundController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/product-not-found/product-not-found.controller.js
 **/